export enum EFormuleSTS {
	fraisReelsPlafonnes = "011",
	ticketModerateur = "052"
}
